import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { API_LINK } from '../../apiLink/apiLink';

const LibraryNewArrivals = ({ onNavigate }) => {
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchNewArrivals = async () => {
            try {
                setLoading(true);
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_LINK}/api/library/new-arrivals`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                const result = await response.json();

                if (result.success) {
                    setBooks(result.data.books || []);
                } else {
                    setError(result.message || 'Failed to fetch new arrivals');
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setError('An error occurred while fetching new arrivals');
            } finally {
                setLoading(false);
            }
        };

        fetchNewArrivals();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
    };

    return (
        <Layout role="librarian" onNavigate={onNavigate} activePage="library-new-arrivals" pageTitle="New Arrivals">
            <div style={{ padding: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
                    <h1 style={{ color: '#333', margin: 0 }}>🆕 New Arrivals</h1>
                </div>

                {error && (
                    <div style={{ backgroundColor: '#ffeef0', color: '#e53935', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #ffccd5' }}>
                        <strong>❌ Error:</strong> {error}
                    </div>
                )}

                {loading ? (
                    <div style={{ display: 'flex', height: '60vh', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                        <div style={{ fontSize: '3rem', animation: 'spin 1s linear infinite' }}>⏳</div>
                        <p style={{ marginTop: '15px', color: '#666' }}>Fetching latest arrivals from the database...</p>
                        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                    </div>
                ) : (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                        gap: '25px'
                    }}>
                        {books.length > 0 ? (
                            books.map(item => (
                                <div key={item.id} style={{
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                                    overflow: 'hidden',
                                    transition: 'transform 0.2s',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ height: '220px', backgroundColor: '#f8f9fa', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
                                        {item.cover_image ? (
                                            <img
                                                src={`${API_LINK}${item.cover_image}`}
                                                alt={item.title}
                                                style={{ height: '190px', width: 'auto', maxWidth: '140px', objectFit: 'cover', borderRadius: '8px', boxShadow: '0 5px 15px rgba(0,0,0,0.2)' }}
                                                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                                            />
                                        ) : null}
                                        {/* Fallback image cover with University styling */}
                                        <div style={{
                                            width: '140px', height: '190px',
                                            backgroundColor: '#238548', color: 'white',
                                            display: item.cover_image ? 'none' : 'flex', flexDirection: 'column',
                                            justifyContent: 'center', alignItems: 'center',
                                            borderRadius: '8px', boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
                                            padding: '10px', textAlign: 'center'
                                        }}>
                                            <div style={{ fontSize: '2rem', marginBottom: '10px' }}>📚</div>
                                            <div style={{ fontWeight: 'bold', fontSize: '0.9rem', lineHeight: '1.2' }}>{item.title}</div>
                                        </div>

                                        <div style={{ position: 'absolute', top: '10px', right: '10px', backgroundColor: '#ff9800', color: 'white', padding: '4px 10px', borderRadius: '20px', fontSize: '0.7rem', fontWeight: 'bold' }}>
                                            NEW
                                        </div>
                                    </div>
                                    <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                        <h3 style={{ margin: '0 0 10px 0', fontSize: '1.1rem', color: '#333', lineHeight: '1.4' }}>{item.title}</h3>
                                        <p style={{ margin: '0 0 5px 0', color: '#666', fontSize: '0.9rem', fontWeight: '500' }}>
                                            By {item.author || 'Unknown'}
                                        </p>
                                        <p style={{ margin: '0 0 5px 0', color: '#888', fontSize: '0.85rem' }}>
                                            <strong>ISBN:</strong> {item.isbn || 'N/A'}
                                        </p>
                                        <p style={{ margin: '0 0 5px 0', color: '#888', fontSize: '0.85rem' }}>
                                            <strong>Acc. No:</strong> {item.accession_number || 'N/A'}
                                        </p>
                                        <p style={{ margin: '0 0 15px 0', color: '#888', fontSize: '0.85rem', flex: 1 }}>
                                            Added on: {formatDate(item.created_at)}
                                        </p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '3rem', color: '#666' }}>
                                No new arrivals in the last 30 days.
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default LibraryNewArrivals;
